import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser'
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { distinctUntilChanged, debounceTime, tap, filter, switchMap, finalize } from 'rxjs/operators';
import { DatePipe, Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { isNumber } from 'highcharts';

import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';
import { MenuFuncionCodes, IncidenciaUsuario, DialogConfirmRequest, DialogConfirmResponse, SaveIncidenciaHilo, ViewHilosRequestDto, SaveIncidenciaUsuario, EstadoConstants, Comunidad, SearchUsuariosRequestDto, SearchComunidadRequest, SearchContratoRequest, Contrato, SearchUnidadFuncionalRequest, UnidadFuncional,
  LocalStorageKeys, Persona, TipoDocumento, SearchTipoDocumentoRequest, DialogPersonaSearchComponentRequestDto, DialogPersonaSearchComponentResponseDto, Proveedor, SearchProveedorRequest, SearchPedidoRequestDto, SearchUsuariosItemDto, PedidoDto, IncidenciaUsuarioCategoriaDto, IncidenciaUsuarioCategoriaCustomDto, SaveIncidenciaUsuarioCampoCustom
 } from '../../../../../src/app/shared/model';
import { IncidenciaHiloAdjunto, SearchIncidenciaHiloItemDto, SearchEstadoRequest, Estado, IncidenciaUsuarioCategoria, SearchIncidenciaUsuarioCategoriaRequest } from '../../../../../src/app/shared/model';

import { MenuFuncionService, EstadoService, IncidenciaUsuarioService, IncidenciaUsuarioCategoriaService, UsuarioService, ComunidadService, TipoDocumentoService, PersonaService, PedidoService, ProveedorService, ContratoService, UnidadFuncionalService } from '../../../../../src/app/shared/services/index';

import { DialogConfirmComponent } from '../../../../../src/app/shared/components/modals/dialogConfirm.component';
import { DialogPersonaSearchComponent } from '../../usuarios/components/dialogPersonaSearch.component';

@Component({
    selector: 'app-incidenciaUsuarioBackofficeEdit',
    templateUrl: './incidenciaUsuarioBackofficeEdit.component.html',
    styleUrls: ['./incidenciaUsuarioBackoffice.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class IncidenciaUsuarioBackofficeEditComponent implements OnInit {
    public tools: object = {};
    public insertImageSettings: object = {};

    formGroup: FormGroup;
    formResponse: FormGroup;

    debeEnviarMail: boolean = false;
    isValidating: boolean = false;
    isSearching: boolean = false;
    isHiloSearching: boolean = false;
    isAttachmentSearching: boolean = false;
    isSaving: boolean = false;
    isDeleting: boolean = false;
    isClosed: boolean = false;
    isFileAttaching: boolean = false;
    isCategoriaSearching: boolean = false;
    isTipoDocumentoSearching: boolean = false;
    isComunidadSearching: boolean = false;
    isPersonSaving: boolean = false;
    isPersonaSearching: boolean = false;
    isProveedorAutoSearching: boolean = false;
    isContratoAutoSearching: boolean = false;
    isPedidoAutoSearching: boolean = false;
    isSubCategoriaSearching: boolean = false;
    isUnidadesFuncionalesSearching: boolean = false;

    canEdit: boolean = false;
    canPersonEdit: boolean = false;
    canViewPersonDetail: boolean = false;
    canAsociarComunidad: boolean = false;
    canAsociarPedido: boolean = false;
    canAsociarPersona: boolean = false;
    canAsociarProveedor: boolean = false;
    canAsociarContrato: boolean = false;
    canAsociarUnidadFuncional: boolean = false;

    categoriaList: IncidenciaUsuarioCategoriaDto[];
    categoriaCamposCustomList: IncidenciaUsuarioCategoriaCustomDto[];
    subCategoriasList: IncidenciaUsuarioCategoria[] = [];
    persona: Persona = new Persona(0, null, null, null, null, null, null, null, null, null, true, null, null, null);

    tipoDocumentoList: TipoDocumento[];
    comunidadList: Comunidad[];
    filteredPedidoList: PedidoDto[] = [];
    filteredProveedorList: Proveedor[] = [];
    filteredContratoList: Contrato[] = [];
    ufList: UnidadFuncional[];

    isEstadoSearching: boolean = false;
    estadoList: Estado[];

    destinatarios: string = "";
    msgError: string = "";
    hiloList: SearchIncidenciaHiloItemDto[];
    item: IncidenciaUsuario;
    newMensaje: SaveIncidenciaHilo;
    adjuntosList: IncidenciaHiloAdjunto[];

    isUsuarioSearching: boolean = false;
    filteredUsuarioList: SearchUsuariosItemDto[];
    usuarioList: any[];

    incidenciaUsuarioSubCategoriaId: number | null;
    loggedUserId: number | null;
    hasSearched: boolean = false;
    pageNumber: number = -1;
    personaFormGroup: FormGroup;
    personaMsgError: string;
    camposCustomGroup: FormGroup;
    codigoRequerido: boolean = false;
    renderCamposCustom: boolean = true;

    constructor(
        private formBuilder: FormBuilder,
        private location: Location,
        public dialog: MatDialog,
        private sharedFunctions: SharedFunctions,
        private route: ActivatedRoute,
        private router: Router,
        private sanitizer: DomSanitizer,
        private menuFuncionService: MenuFuncionService,
        private incidenciaUsuarioService: IncidenciaUsuarioService,
        private categoriaService: IncidenciaUsuarioCategoriaService,
        public tipoDocumentoService: TipoDocumentoService,
        private estadoService: EstadoService,
        private usuarioService: UsuarioService,
        private comunidadService: ComunidadService,
        private unidadFuncionalService: UnidadFuncionalService,
        private personaService: PersonaService,
        private proveedorService: ProveedorService,
        private pedidoService: PedidoService,
        private contratoService: ContratoService,
        private datePipe: DatePipe
    ) {
    }

    ngOnInit(): void {
        this.isValidating = true;
        this.menuFuncionService.checkMenuPadre(MenuFuncionCodes.INCIDENCIA_USUARIO).subscribe(data => {
            this.isValidating = false;
            if (data != null && data.Success && data?.Result) {
                this.canEdit = data.Result.some(x => x == MenuFuncionCodes.INCIDENCIA_USUARIO_EDIT_BO);
                this.canAsociarComunidad = data.Result.some(x => x == MenuFuncionCodes.INCIDENCIA_USUARIO_ASOCIAR_COMUNIDAD);
                this.canAsociarPedido = data.Result.some(x => x == MenuFuncionCodes.INCIDENCIA_USUARIO_ASOCIAR_PEDIDO);
                this.canAsociarPersona = data.Result.some(x => x == MenuFuncionCodes.INCIDENCIA_USUARIO_ASOCIAR_PERSONA);
                this.canAsociarProveedor = data.Result.some(x => x == MenuFuncionCodes.INCIDENCIA_USUARIO_ASOCIAR_PROVEEDOR);
                this.canAsociarContrato = data.Result.some(x => x == MenuFuncionCodes.INCIDENCIA_USUARIO_ASOCIAR_CONTRATO);
                this.canAsociarUnidadFuncional = data.Result.some(x => x == MenuFuncionCodes.INCIDENCIA_USUARIO_ASOCIAR_UF);

                this.loadView();
            }
            else {
                this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
                this.onCancel();
            }
        },
        (err: HttpErrorResponse) => {
            this.isValidating = false;
            this.sharedFunctions.handleError(err, true);
        });
        this.tools = this.sharedFunctions.getRichTextToolbarItems();
        this.insertImageSettings = this.sharedFunctions.getRichTextImageSettings
            (
                "incidenciahilo", //this.incidenciaUsuarioService.getResourceName(),
                this.incidenciaUsuarioService.uploadAttachTempUrl()
            ) ?? {};

    }

    loadView() {
        var loggedUser = this.sharedFunctions.getLoggedUser();
        if (loggedUser?.Id !== undefined)
          this.loggedUserId = loggedUser?.Id;

        this.menuFuncionService.checkMenuPadre(MenuFuncionCodes.PERSONA).subscribe(data => {
            if (data != null && data.Success && data?.Result) {
                this.canPersonEdit = data.Result.some(x => x == MenuFuncionCodes.PERSONA_ADD || x == MenuFuncionCodes.PERSONA_EDIT);
                this.canViewPersonDetail = data.Result != null && data.Result.length > 0;
            }
        },
        (err: HttpErrorResponse) => {
            this.sharedFunctions.handleError(err);
        });

        this.buildForm();
        this.buildPersonForm();

        this.getProveedoresAutocomplete();
        this.getPedidosAutocomplete();
        this.getContratosAutocomplete();
        this.getUsuariosAutocomplete();

        this.getTiposDocumento();
        this.getCategorias();
        this.getEstados();
        this.getComunidades();

        this.loadEntity();
    }

    buildForm() {
        this.formGroup = this.formBuilder.group({
            'IncidenciaUsuarioCategoriaId': [null, Validators.required],
            'UsuarioAsignadoId': [null],
            'UsuarioAsignado': [null],
            'FechaLimite': [null],
            'ComunidadId': [null],
            'UnidadFuncionalId': [null],
            'Pedido': [null],
            'PedidoId': [null],
            'ProveedorId': [null],
            'Proveedor': [null],
            'Contrato': [null],
            'EstadoId': [null],
            'Codigo': [null]
        });

        this.formResponse = this.formBuilder.group({
            'Mensaje': [null]
        });
    }

    getCategorias() {
        var r = new SearchIncidenciaUsuarioCategoriaRequest(null, null, true, "Nombre", null, null, true, true);
        this.isCategoriaSearching = true;

        this.categoriaService.search(r).subscribe(data => {
            this.isCategoriaSearching = false;
            this.categoriaList = data?.result;
        },
        (err: HttpErrorResponse) => {
            this.isCategoriaSearching = false;
            this.sharedFunctions.handleError(err);
        })
    }

    getComunidades() {
        var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
        if (cId != null && cId.length > 0 && cId > 0)
            cId = Number(cId);

        var r = new SearchComunidadRequest(null, null, true, "Nombre", null, cId, null, null, null, true);
        this.isComunidadSearching = true;

        this.comunidadService.search(r).subscribe(data => {
            this.isComunidadSearching = false;
            if (data != null)
                this.comunidadList = data?.result;
        },
        (err: HttpErrorResponse) => {
            this.isComunidadSearching = false;
            this.sharedFunctions.handleError(err);
        });
    }

    getEstados() {
        var r = new SearchEstadoRequest(null, null, true, "Nombre", null, null, true);
        this.isEstadoSearching = true;

        this.estadoService.searchIncidenciaEstados(r).subscribe(data => {
            this.isEstadoSearching = false;
            this.estadoList = data?.result;
        },
            (err: HttpErrorResponse) => {
                this.isEstadoSearching = false;
                this.sharedFunctions.handleError(err);
            })
    }

    onCategoriaSelect() {
        this.incidenciaUsuarioSubCategoriaId = null;
        this.codigoRequerido = this.categoriaList.find(x=>x.Id == this.formGroup.value.IncidenciaUsuarioCategoriaId)?.CodigoRequerido ?? false;
        if(this.codigoRequerido){
            this.formGroup.get('Codigo')?.setValidators(Validators.required);
            this.formGroup.get('Codigo')?.updateValueAndValidity();
        }else{
            this.formGroup.get('Codigo')?.setValidators(null);
            this.formGroup.get('Codigo')?.updateValueAndValidity();
        }
        this.getCategoriaCamposCustom();
        this.getSubCategorias();
    }

    getSubCategorias() {
        var categoriaId = this.formGroup.get("IncidenciaUsuarioCategoriaId")?.value;
        if (categoriaId != null && categoriaId > 0) {
            this.isSubCategoriaSearching = true;
            this.categoriaService.getSubCategorias(categoriaId).subscribe(data => {
                this.isSubCategoriaSearching = false;
                this.subCategoriasList = data?.Result;
            },
                (err: HttpErrorResponse) => {
                    this.isSubCategoriaSearching = false;
                    this.sharedFunctions.handleError(err);
                })
        }
    }

    getProveedoresAutocomplete() {
        if (!this.canAsociarProveedor)
            return false;

        this.formGroup.get('Proveedor')?.valueChanges
          .pipe(
            filter(res => {
              return res && res !== null && res.length >= 3
            }),
            distinctUntilChanged(),
            debounceTime(1000),
            tap(() => {
              this.filteredProveedorList = [];
              this.isProveedorAutoSearching = true;
            }),
            switchMap(value => this.proveedorService.search(new SearchProveedorRequest(null, null, true, "RazonSocial", null, !isNumber(parseInt(value)) ? value : null, isNumber(parseInt(value)) ? value : null, null, null, null, true))
              .pipe(
                finalize(() => {
                  this.isProveedorAutoSearching = false;
                }),
              )
            )
          )
          .subscribe((data: any) => {
            if (data != null && data.result != null)
              this.filteredProveedorList = data.result;
            else
              this.filteredProveedorList = [];
            // (this.filteredProveedorList, 'lista proveedor')
          });
    }

    getPedidosAutocomplete() {
        if (!this.canAsociarPedido)
            return false;

        this.formGroup.get('Pedido')?.valueChanges
            .pipe(
                filter(res => {
                    return res && res !== null && res.length >= 1
                }),
                distinctUntilChanged(),
                debounceTime(1000),
                tap(() => {
                    this.filteredPedidoList = [];
                    this.isPedidoAutoSearching = true;
                }),
                switchMap(value => this.pedidoService.search(new SearchPedidoRequestDto(null, null, true, "Id", isNumber(parseInt(value)) ? value : null, null, null, null, null, true, null, true, null))
                    .pipe(
                        finalize(() => {
                            this.isPedidoAutoSearching = false;
                        }),
                    )
                )
            )
            .subscribe((data: any) => {
                if (data != null && data.result != null)
                    this.filteredPedidoList = data.result;
                else
                    this.filteredPedidoList = [];
                // (this.filteredProveedorList, 'lista proveedor')
            });
    }

    getContratosAutocomplete() {
        if (!this.canAsociarContrato)
            return false;

        this.formGroup.get('Contrato')?.valueChanges
            .pipe(
                filter(res => {
                    return res && res !== null && res.length >= 1
                }),
                distinctUntilChanged(),
                debounceTime(1000),
                tap(() => {
                    this.filteredContratoList = [];
                    this.isContratoAutoSearching = true;
                }),
                switchMap(value => this.contratoService.search(new SearchContratoRequest(null, null, true, "Codigo", value, null, null, null, null, null, null, null, null, null, null, true))
                    .pipe(
                        finalize(() => {
                            this.isContratoAutoSearching = false;
                        }),
                    )
                )
            )
            .subscribe((data: any) => {
                if (data != null && data.result != null)
                    this.filteredContratoList = data.result;
                else
                    this.filteredContratoList = [];
                // (this.filteredContratoList, 'lista contrato')
            });
    }

    getUsuariosAutocomplete() {
        this.formGroup.get('UsuarioAsignado')?.valueChanges
            .pipe(
                filter(res => {
                    return res && res !== null && res.length >= 3
                }),
                distinctUntilChanged(),
                debounceTime(1000),
                tap(() => {
                    this.filteredUsuarioList = [];
                    this.isUsuarioSearching = true;
                }),
                switchMap(value => this.usuarioService.search(new SearchUsuariosRequestDto(null, null, true, "Login", value, null, null, null, null, null, null, null, null, true, null))
                    .pipe(
                        finalize(() => {
                            this.isUsuarioSearching = false;
                        }),
                    )
                )
            )
            .subscribe((data: any) => {
                if (data != null && data.result != null)
                    this.filteredUsuarioList = data.result;
                else
                    this.filteredUsuarioList = [];
                // (this.filteredProveedorList, 'lista proveedor')
            });
    }

    loadEntity() {
        this.newMensaje = new SaveIncidenciaHilo(null, null, null, [], []);
        this.route.params.subscribe(params => {
            if (params['id'] != null && params['id'] != '0') {
                var id = Number(params['id']);

                if (id > 0) {
                    this.isSearching = true;
                    this.incidenciaUsuarioService.get(id).subscribe(data => {
                        this.isSearching = false;
                        if (data != null && data.Success) {
                            this.item = data.Result;

                            if (this.item != null && this.item.Id > 0) {
                                if (this.item.PersonaId > 0)
                                    this.getPersona();

                                if (this.item.Editable) {
                                    this.formGroup.patchValue(this.item);

                                    if (this.item.IncidenciaUsuarioCategoriaPadreId > 0) {
                                        this.incidenciaUsuarioSubCategoriaId = this.item.IncidenciaUsuarioCategoriaId;
                                        this.formGroup.get("IncidenciaUsuarioCategoriaId")?.setValue(this.item.IncidenciaUsuarioCategoriaPadreId);
                                    }

                                    this.getSubCategorias();

                                    this.setUsuarioAsignadoForm();
                                    this.setProveedorForm();
                                    this.setPedidoForm();
                                    this.setContratoForm();

                                    this.onFiltroUfComunidadSelect(false);

                                    this.categoriaCamposCustomList = this.item.IncidenciaUsuarioCategoriaCustom;
                                    this.getCategoriaCamposCustom();
                                    this.patchCustomValuesOnFormGroup();
                                    this.getCampoActivo();
                                    if(this.categoriaCamposCustomList?.length > 0)
                                        this.renderCamposCustom = true;
                                }

                                this.loadHilos();
                            }
                            else
                                this.msgError = "No se encontró el incidente seleccionado.";
                        }
                        else
                            this.msgError = "Ocurrió un error al intentar obtener los datos del incidente.";
                    },
                        (err: HttpErrorResponse) => {
                            this.isSearching = false;
                            this.sharedFunctions.handleError(err, true);
                        })
                }
                else
                    this.msgError = "Item no válido.";
            }
            else
                this.msgError = "Debe seleccionar un incidente para visualizarlo.";
        });
    }

    setUsuarioAsignadoForm() {
        if (this.item.UsuarioAsignadoId != null && this.item.UsuarioAsignadoId > 0) {
            var u = new SearchUsuariosItemDto(this.item.UsuarioAsignadoId, null, this.item.UsuarioAsignadoLogin, this.item.UsuarioAsignadoNombre, this.item.UsuarioAsignadoApellido, null, null, null, null, true, false, null, null, null);

            this.filteredUsuarioList = [u];
            this.formGroup.get("UsuarioAsignado")?.setValue(u);
        }
    }

    setProveedorForm() {
        if (this.item.ProveedorId != null && this.item.ProveedorId > 0) {
            var u = new Proveedor(this.item.ProveedorId, null, this.item.ProveedorNombre, null, null, null, null, null, null, null, null, null, null, null, null,null, null,[]);

            this.filteredProveedorList = [u];
            this.formGroup.get("Proveedor")?.setValue(u);
        }
    }

    setPedidoForm() {
        if (this.item.PedidoId != null && this.item.PedidoId > 0) {
            this.isPedidoAutoSearching = true;
            this.pedidoService.get(this.item.PedidoId).subscribe(data => {
                this.isPedidoAutoSearching = false;
                if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {
                    this.filteredPedidoList = [data.Result];
                    this.formGroup.get("Pedido")?.setValue(data.Result);
                }
            },
                (err: HttpErrorResponse) => {
                    this.isPedidoAutoSearching = false;
                    this.sharedFunctions.handleError(err, true);
                })
        }
    }

    setContratoForm() {
        if (this.item.ContratoId != null && this.item.ContratoId > 0) {
            this.isContratoAutoSearching = true;
            this.contratoService.get(this.item.ContratoId).subscribe(data => {
                this.isContratoAutoSearching = false;
                if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {
                    this.filteredContratoList = [data.Result];
                    this.formGroup.get("Contrato")?.setValue(data.Result);
                }
            },
            (err: HttpErrorResponse) => {
                this.isContratoAutoSearching = false;
                this.sharedFunctions.handleError(err, true);
            })
        }
    }

    getErrorIncidenciaUsuarioCategoriaId() {
        return this.formGroup.get('IncidenciaUsuarioCategoriaId')?.hasError('required') ? 'El campo es obligatorio' : '';
    }

    getErrorEstadoId() {
        return this.formGroup.get('EstadoId')?.hasError('required') ? 'El campo es obligatorio' : '';
    }

    markHiloAsRead(id) {
        this.incidenciaUsuarioService.markHiloAsRead(id).subscribe(data => {
            if (data != null && data.Success)
                this.incidenciaUsuarioService.informMessageRead(id);
        },
        (err: HttpErrorResponse) => {
            this.sharedFunctions.handleError(err);
        })
    }

    mostrarTabAsociaciones() {
        if (this.canAsociarComunidad || this.canAsociarPedido || this.canAsociarPersona || this.canAsociarProveedor || this.canAsociarContrato || this.canAsociarUnidadFuncional) {
            if (this.item != null && this.item.Id > 0) {
                return (this.item.ComunidadId > 0 || this.item.PedidoId > 0 || this.item.UnidadFuncionalId > 0 ||
                            this.item.PersonaId > 0 || this.item.ProveedorId > 0 || this.item.ContratoId > 0);
            }
            else
                return true;
        }
        return false;
    }

    loadHilos() {

        this.hasSearched = true;
        this.pageNumber++;

        var search = new ViewHilosRequestDto(10, this.pageNumber, true, "FechaCreacion", this.item.Id);
        this.isHiloSearching = true;

        this.incidenciaUsuarioService.viewHilos(search).subscribe(data => {
            this.isHiloSearching = false;
            if (data != null) {
                if (data.result != null && data.result.length > 0) {
                    if (this.hiloList == null)
                        this.hiloList = [];

                    for (var i = 0; i < data.result.length; i++) {
                        data.result[i].MensajeHtml = this.sanitizer.bypassSecurityTrustHtml(data.result[i].Mensaje || '' );
                        data.result[i].Adjuntos = data.result[i].Adjuntos?.filter(f => !f.IncluidoEnCuerpoMensaje);

                        if (!data.result[i].Leido)
                            this.markHiloAsRead(data.result[i].Id);

                        this.hiloList.push(data.result[i]);

                        if (this.pageNumber == 0)
                            this.scrollearAlFinal();
                    }
                }
            }
            else
                this.msgError = "Ocurrió un error al intentar obtener los datos de los hilos.";
        },
            (err: HttpErrorResponse) => {
                this.isHiloSearching = false;
                this.sharedFunctions.handleError(err, true);
            })
    }

    scrollearAlFinal() {
        setTimeout(() => {
            var objDiv = document.getElementById("hiloMensajesDiv");
            if (objDiv != null)
                objDiv.scrollTop = objDiv.scrollHeight;
        }, 500);
    }

    onCancel() {
        this.location.back();
    }

    isProcessing() {
        return (this.isSearching || this.isSaving);
    }

    onFiltroUfComunidadSelect(clearUf: boolean = true) {
        if (!this.canAsociarUnidadFuncional)
            return;

        if (clearUf)
            this.formGroup?.get("UnidadFuncionalId")?.setValue(null);

        var cId = this.formGroup?.get("ComunidadId")?.value;
        if (cId == null || cId <= 0) {
            this.ufList = [];
            return false;
        }

        var r = new SearchUnidadFuncionalRequest(null, null, true, "Codigo", null, null, null, null, null, null, cId, null, true);
        this.isUnidadesFuncionalesSearching = true;

        this.unidadFuncionalService.search(r).subscribe(data => {
            this.isUnidadesFuncionalesSearching = false;
            this.ufList = data.result;
        },
        (err: HttpErrorResponse) => {
            this.isUnidadesFuncionalesSearching = false;
            this.sharedFunctions.handleError(err);
        })
    }

    onSaveCategoriaCamposCustom(): SaveIncidenciaUsuarioCampoCustom[]{
        var saveCamposCustom: SaveIncidenciaUsuarioCampoCustom[] = [];
        if(this.categoriaCamposCustomList?.length > 0){
            this.categoriaCamposCustomList.forEach(value => {
               if (value.NombreCampo) {
                var campoCustom = new SaveIncidenciaUsuarioCampoCustom(this.item?.IncidenciaUsuarioCampoCustom?.find(x => x.IncidenciaUsuarioCategoriaCustomId == value.Id)?.Id ?? 0, this.camposCustomGroup.value[value.NombreCampo], value.Id, this.item.Id, true);
                saveCamposCustom.push(campoCustom);
               }
            });
        }
        return saveCamposCustom;
    }

    onGuardarIncidencia() {
        var camposCustom = this.onSaveCategoriaCamposCustom();

        var r = new SaveIncidenciaUsuario(this.item.Id, this.item.Asunto, null, this.item.IncidenciaUsuarioCategoriaId, this.item.ComunidadId, this.item.EstadoId, this.item.FechaLimite, this.item.UsuarioAsignadoId, this.item.PersonaId, [], [], []);
        r =
        {
            ...this.formGroup.value,
            ...{
                Id: (this.item?.Id ?? 0),
                Asunto: (this.item?.Asunto),
                PersonaId: this.persona?.Id,
                IncidenciaUsuarioCategoriaId: this.incidenciaUsuarioSubCategoriaId ? this.incidenciaUsuarioSubCategoriaId : this.formGroup.value.IncidenciaUsuarioCategoriaId,
                IncidenciaUsuarioCampoCustoms: camposCustom,
                Persona: this.personaFormGroup?.getRawValue(),
                PedidoId: this.formGroup.get("Pedido")?.value?.Id
            }
        };

        if (r.EstadoId == EstadoConstants.ESTADO_INCIDENCIA_CERRADA) {
            const dialogRef = this.dialog.open(DialogConfirmComponent, {
                data: new DialogConfirmRequest(null, "¿Está seguro que desea cerrar el incidente?", null, null)
            });

            dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {

                if (result != null && result.Accepted) {
                    this.doGuardarIncidente(r);
                }
            });
        }
        else
            this.doGuardarIncidente(r);
    }

    doGuardarIncidente(r: SaveIncidenciaUsuario) {
        this.onUsuarioAsignadoChange();
        this.isSaving = true;
        this.incidenciaUsuarioService.save(r).subscribe(data => {
            this.isSaving = false;
            if (data != null && data.Success) {
                this.sharedFunctions.showMessage("Se guardó exitosamente la incidencia!", "Operación Exitosa!");

                if (r.EstadoId == EstadoConstants.ESTADO_INCIDENCIA_CERRADA)
                    this.sharedFunctions.reloadCurrentRoute();
                else
                    this.loadHilos();
            }
            else
                this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
        },
            (err: HttpErrorResponse) => {
                this.isSaving = false;
                this.sharedFunctions.handleError(err, true);
            })
    }

    onGuardar() {

        if (!this.formResponse.valid) {
            this.sharedFunctions.showMessage("Por favor escriba un mensaje para continuar", "Error");
            return false;
        }

        this.doSave();
    }

    doSave() {
        var r = new SaveIncidenciaHilo(null, null, null, [], []);

        if (this.adjuntosList == null)
            this.adjuntosList = [];

        r =
        {
            ...this.formResponse.value,
            ...
            {
                IncidenciaId: (this.item?.Id ?? 0),
                Adjuntos: this.adjuntosList,
                // IncidenciaUsuarioCategoriaId: this.incidenciaUsuarioSubCategoriaId ? this.incidenciaUsuarioSubCategoriaId : this.formGroup.value.IncidenciaUsuarioCategoriaId,
                PersonaId: this.persona?.Id,
                Persona: this.personaFormGroup?.getRawValue(),
                PedidoId: this.formGroup.get("Pedido")?.value?.Id,
                ContratoId: this.formGroup.get("Contrato")?.value?.Id,
                EnviarMail: this.debeEnviarMail,
                Destinatarios: this.destinatarios,
            }
        };

        this.isSaving = true;
        this.incidenciaUsuarioService.saveHilo(r).subscribe(data => {
            this.isSaving = false;
            if (data != null && data.Success) {
                this.sharedFunctions.showMessage("Se guardó exitosamente la respuesta!", "Operación Exitosa!");

                this.formResponse.reset();
                this.adjuntosList = [];

                this.pageNumber = -1;
                this.loadHilos();
            }
            else
                this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
        },
            (err: HttpErrorResponse) => {
                this.isSaving = false;
                this.sharedFunctions.handleError(err, true);
            })
    }

    onFileAttachedDelete(item: any) {
        if (item.Id > 0)
            this.onExistingFileAttachedDelete(item);
        else
            this.onNewFileAttachedDelete(item);
    }

    onNewFileAttach(event: any) {
        if (event?.target?.files != null && event.target.files.length > 0) {
            var fileList = event.target.files;

            if (this.adjuntosList == null)
                this.adjuntosList = [];

            for (var i = 0; i < fileList.length; i++) {
                if (this.adjuntosList.find(f => f.NombreDocumento == fileList[i].name)) {
                    this.sharedFunctions.showMessage("Ya existe un archivo con ese nombre. Por favor modifique el nombre del archivo o elimine el ya adjuntado", "Error");
                    return false;
                }
            }

            if (fileList != null && fileList.length > 0) {
                this.isFileAttaching = true;
                this.incidenciaUsuarioService.uploadAttachTemp(fileList).subscribe(data => {
                    this.isFileAttaching = false;
                    if (data != null && data.Success && data.Result != null && data.Result.Archivos != null && data.Result.Archivos.length > 0) {
                        for (let i = 0; i < data.Result.Archivos.length; i++) {
                            if (data.Result.Archivos[i] != null) {
                                this.adjuntosList.push(data.Result.Archivos[i]);
                            }
                        }
                    }
                    else
                        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error intentando subir los archivos", "Error");
                },
                    (err: HttpErrorResponse) => {
                        this.isFileAttaching = false;
                        this.sharedFunctions.handleError(err, true);
                    })
            }
        }
    }

    onExistingFileAttachedDelete(item: any) {
        if (this.adjuntosList != null && this.adjuntosList.length > 0) {
            var index = this.adjuntosList.findIndex(f => f.Id == item.Id);

            if (index >= 0)
                this.adjuntosList.splice(index, 1);
        }
    }

    onNewFileAttachedDelete(item: any) {
        if (this.adjuntosList != null && this.adjuntosList.length > 0) {
            var index = this.adjuntosList.findIndex(f => f.Id == item.Id);

            if (index >= 0) {
                this.adjuntosList.splice(index, 1);
            }
        }
    }

    public imageUploading(args: any): void {
        if (args != null) {
            args.currentRequest.setRequestHeader(
                this.incidenciaUsuarioService.getAuthorizationHeaderParameterName(),
                this.incidenciaUsuarioService.getAuthorizationHeaderParameterValue()
            );
        }
    }

    public imageUploadSuccess(args: any): void {

        if (args != null && args.file != null) {
            let filename: any = document.querySelectorAll(".e-file-name")[0];

            if (filename != null) {
                filename.innerHTML = args.file.name.replace(document.querySelectorAll(".e-file-type")[0].innerHTML, '');
                filename.title = args.file.name;
            }
        }
    }

    displayUsuario(usuario: any) {
        return usuario != null && usuario.Id > 0 ? usuario.Login + " - " + usuario.Nombre + " " + usuario.Apellido : '';
    }

    displayProveedor(proveedor: Proveedor): string {
        return proveedor && proveedor?.RazonSocial ? proveedor.RazonSocial : '';
    }

    displayPedido(item: any): string {
        return item && item.Id != null && item.Id > 0 ? ("#" + item.Id + " - " + item.ComunidadOrigenNombre + " > " + item.ComunidadDestinoNombre) : '';
    }

    displayContrato(item: any): string {
        return item && item.Id != null && item.Id > 0 ? item.Codigo : '';
    }

    onUsuarioAsignadoChange() {
        this.formGroup.get("UsuarioAsignadoId")?.setValue(null);
        if (this.formGroup.get("UsuarioAsignado")?.value != null)
            this.formGroup.get("UsuarioAsignadoId")?.setValue(this.formGroup.get("UsuarioAsignado")?.value?.Id);
    }

    onProveedorChange() {
        this.formGroup.get("ProveedorId")?.setValue(null);
        if (this.formGroup.get("Proveedor")?.value != null)
            this.formGroup.get("ProveedorId")?.setValue(this.formGroup.get("Proveedor")?.value?.Id);
    }

    //Datos Persona/Vecino -------------------->

    buildPersonForm() {
        this.personaFormGroup = this.formBuilder.group({
            'Nombre': [null, [Validators.required, Validators.maxLength(150)]],
            'Apellido': [null, [Validators.required, Validators.maxLength(150)]],
            'TipoDocumentoId': [null],
            'NroDocumento': [null, Validators.maxLength(100)],
            'Cuit': [null],
            'FechaNacimiento': [null],
            'MailContacto': [null, [Validators.maxLength(255), Validators.email]],
            'MovilContacto': [null, Validators.maxLength(100)],
            'DomicilioReal': [null, Validators.maxLength(150)]
        });
    }

    getTiposDocumento() {
        var r = new SearchTipoDocumentoRequest(null, null, true, "Nombre", null, null, true);
        this.isTipoDocumentoSearching = true;

        this.tipoDocumentoService.search(r).subscribe(data => {
            this.isTipoDocumentoSearching = false;
            if (data != null) {
                this.tipoDocumentoList = data?.result;
            }
        },
        (err: HttpErrorResponse) => {
            this.isTipoDocumentoSearching = false;
            this.sharedFunctions.handleError(err);
        });
    }

    clearDatePersonForm(formFieldName: string) {
        if (formFieldName != null && formFieldName.length > 0) {
            if (this.personaFormGroup?.get(formFieldName) != null && this.personaFormGroup?.get(formFieldName)?.value)
                this.personaFormGroup?.get(formFieldName)?.setValue(null);
        }
    }

    getErrorNombre() {
        var v = this.personaFormGroup?.get('Nombre');
        if (v?.hasError('required'))
            return 'El campo es obligatorio';
        if (v?.hasError('maxlength'))
            return 'Límite de 150 caracteres alcanzado';
        return '';
    }

    getErrorApellido() {
        var v = this.personaFormGroup?.get('Apellido');
        if (v?.hasError('required'))
            return 'El campo es obligatorio';
        if (v?.hasError('maxlength'))
            return 'Límite de 150 caracteres alcanzado';
        return '';
    }

    getErrorFechaNacimiento() {
        return this.personaFormGroup?.get('FechaNacimiento')?.hasError('required') ? 'El campo es obligatorio' : '';
    }

    getErrorTipoDocumentoId() {
        return this.personaFormGroup?.get('TipoDocumentoId')?.hasError('required') ? 'El campo es obligatorio' : '';
    }

    getErrorNroDocumento() {
        var v = this.personaFormGroup?.get('NroDocumento');
        if (v?.hasError('maxlength'))
            return 'Límite de 100 caracteres alcanzado';
        return '';
    }

    getErrorCuit() {
        return this.personaFormGroup?.get('Cuit')?.hasError('required') ? 'El campo es obligatorio' : '';
    }

    getErrorMailContacto() {
        var v = this.personaFormGroup?.get('MailContacto');
        if (v?.hasError('maxlength'))
            return 'Límite de 255 caracteres alcanzado';
        if (v?.hasError('email'))
            return 'Debe ingresar un email con formato válido';
        return '';
    }

    getErrorMovilContacto() {
        var v = this.personaFormGroup?.get('MovilContacto');
        if (v?.hasError('maxlength'))
            return 'Límite de 100 caracteres alcanzado';
        return '';
    }

    getErrorDomicilioReal() {
        var v = this.personaFormGroup?.get('DomicilioReal');
        if (v?.hasError('maxlength'))
            return 'Límite de 150 caracteres alcanzado';
        return '';
    }

    onPersonSearchClick() {
        if (this.isProcessing())
            return;

        const dialogRef = this.dialog.open(DialogPersonaSearchComponent, {
            width: '90%',
            data: new DialogPersonaSearchComponentRequestDto(false, 0)
        });

        dialogRef.afterClosed().subscribe((result: DialogPersonaSearchComponentResponseDto) => {
            if (result != null && !result.Cancelled) {
                var u = (result.Items != null && result.Items.length > 0 ? result.Items[0] : null);

                this.persona = new Persona(0, null, null, null, null, null, null, null, null, null, true, null, null, null);
                if (u != null && u.Id > 0)
                    this.persona = new Persona(u.Id, u.Nombre, u.Apellido, u.NroDocumento, u.TipoDocumentoNombre, u.TipoDocumentoId, u.FechaNacimiento, u.Cuit, u.MailContacto, u.MovilContacto,
                        u.Activo, u.FotoDniFrenteUrl, u.FotoDniDorsoUrl, u.FotoSelfieUrl);

                this.loadPersonData();
            }
        });
    }

    onPersonDeassociateClick() {
        this.persona = new Persona(0, null, null, null, null, null, null, null, null, null, true, null, null, null);
        if (this.item != null)
            this.item.PersonaId = 0;
        this.loadPersonData();
    }

    canDeassociatePerson() {
        return this.canPersonEdit && this.persona != null && this.persona.Id > 0;
    }

    loadPersonData() {
        if (this.persona != null && this.persona.Id > 0) {
            if (this.canPersonEdit) {
                this.personaFormGroup.patchValue(this.persona);

                if (this.persona.FechaNacimiento != null)
                    this.personaFormGroup?.get("FechaNacimiento")?.setValue(this.datePipe.transform(this.persona.FechaNacimiento, "yyyy-MM-dd"));
            }
        }
    }

    getPersona() {
        this.isPersonaSearching = true;
        this.personaMsgError = "";

        this.personaService.get(this.item.PersonaId).subscribe(data => {
            this.isPersonaSearching = false;
            if (data != null) {
                this.persona = data.Result;
                this.loadPersonData();
            }
            else
                this.personaMsgError = "Ocurrió un error al intentar obtener los datos de la persona.";
        },
            (err: HttpErrorResponse) => {
                this.isPersonaSearching = false;
                this.sharedFunctions.handleError(err);
            })
    }

    goIncidenciaEdicion() {
        if (!this.item || this.item.Id == null || this.item.Id <= 0) {
            this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
            return false;
        }

        this.router.navigate(['incidencia-usuario-edit-bo', this.item.Id]);
    }

    getCategoriaCamposCustom(){
        this.categoriaCamposCustomList = this.categoriaList?.find(x => x.Id == this.formGroup.value.IncidenciaUsuarioCategoriaId && x.Activo)?.IncidenciaUsuarioCategoriaCustomDtos ?? [];
        if(this.item?.IncidenciaUsuarioCategoriaCustom)
            this.categoriaCamposCustomList = this.item?.IncidenciaUsuarioCategoriaCustom.filter(x => x.Activo);
        if(this.categoriaCamposCustomList.length > 0){
            this.camposCustomGroup = this.formBuilder.group({});
            this.categoriaCamposCustomList.forEach(element => {
              if (element.NombreCampo)
                if(element.Requerido){
                    this.camposCustomGroup.addControl(element.NombreCampo, new FormControl(this.item?.IncidenciaUsuarioCampoCustom?.find(x => x.IncidenciaUsuarioCategoriaCustomId == element.Id)?.Valor ?? '', Validators.required))
                }
                else{
                    this.camposCustomGroup.addControl(element.NombreCampo, new FormControl(this.item?.IncidenciaUsuarioCampoCustom?.find(x => x.IncidenciaUsuarioCategoriaCustomId == element.Id)?.Valor ?? ''))
                }
            });
            this.renderCamposCustom = true;
        }
    }

    patchCustomValuesOnFormGroup(){
        this.item.IncidenciaUsuarioCategoriaCustom.forEach(value => {
          if(value.NombreCampo)
            this.camposCustomGroup?.get(value.NombreCampo)?.setValue(this.item.IncidenciaUsuarioCampoCustom.find(x => x.IncidenciaUsuarioCategoriaCustomId == value.Id)?.Valor);
        })
    }

    getErrorCampoCustom(campoCustom: string){
        var v = this.camposCustomGroup?.get(campoCustom);
        if (v?.hasError('required'))
            return 'El campo es obligatorio';
        if (v?.hasError('maxlength'))
            return 'Límite de 255 caracteres alcanzado';
        return '';
    }

    clearDate(formFieldName: string) {
        if (formFieldName != null && formFieldName.length > 0) {
            if (this.formGroup.get(formFieldName) != null && this.formGroup.get(formFieldName)?.value)
            this.formGroup.get(formFieldName)?.setValue(null);
        }
    }

    getCampoActivo(){
        return this.categoriaCamposCustomList?.some(x => x.Activo);
    }

    getNombreCampo(item: IncidenciaUsuarioCategoria){
        return this.item.IncidenciaUsuarioCategoriaCustom.find(x => x.Id == item.Id)?.NombreCampo;
    }

    getValorCampo(item: IncidenciaUsuarioCategoria){
        return this.item.IncidenciaUsuarioCampoCustom.find(x => x.IncidenciaUsuarioCategoriaCustomId == item.Id)?.Valor
    }

    onCheckEnvioEmail(event){
        this.debeEnviarMail = event.checked;
        this.destinatarios = this.item.Destinatarios ?? '';
    }

    viewPersona(id: number) {
        if (id == null || id <= 0) {
          this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
          return false;
        }

        if (!this.canViewPersonDetail)
            return false;

        this.router.navigate(['persona-edit', id]);
    }
}
